import { render, staticRenderFns } from "./QPreview.vue?vue&type=template&id=127322f9&scoped=true&"
import script from "./QPreview.vue?vue&type=script&lang=js&"
export * from "./QPreview.vue?vue&type=script&lang=js&"
import style0 from "./QPreview.vue?vue&type=style&index=0&id=127322f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127322f9",
  null
  
)

export default component.exports